import { ChainId } from '@pancakeswap/sdk'
import addresses from '~/config/constants/contracts'
import { Address } from '~/config/constants/types'

export const getAddress = (chainId: number, address: Address): string => {
  // const chainId = process.env.REACT_APP_CHAIN_ID
  return address[chainId] ? address[chainId] : address[ChainId.MAINNET]
}

export const getRouterAddress = (chainId: number) => {
  return getAddress(chainId, addresses.router);
}

export const getMasterChefAddress = (chainId: number) => {
  return getAddress(chainId, addresses.masterChef)
}
export const getMulticallAddress = (chainId: number) => {
  return getAddress(chainId, addresses.multiCall)
}

export const getFairlaunchAddress = (chainId: number) => {
  return getAddress(chainId,addresses.fairlaunch)
}
export const getFarmZapAddress = (chainId: number) => {
  return getAddress(chainId,addresses.farmZap)
}

export const getNftMarketAddress = (chainId: number) => {
  return getAddress(chainId, addresses.nftMarket)
}

export const getCakeVaultAddress = (chainId: number) => {
  return getAddress(chainId,addresses.cakeVault)
}

export const getChainlinkOracleAddress = (chainId: number) => {
  return getAddress(chainId,addresses.chainlinkOracle)
}

export const getPriceGetterAddress = (chainId: number) => {
  return getAddress(chainId,addresses.priceGetter)
}

export const  getPancakeProfileAddress = (chainId: number) => {
  return undefined
}

export const getFeeManagerAddress = (chainId: number) => {
  return getAddress(chainId, addresses.feeManager)
}
